<template>
	<v-dialog v-model="dialog" width="700">
		<custom-dialog>
			<template v-slot:title>
				{{ 'カメラ追加' }}
				<button id="dialog_exit">
					<img src="@/assets/images/popup_close.png" id="btn_img" @click="dialog = false">
				</button>
			</template>
			<template v-slot:body>
				<v-row class="ma-0 pa-0" justify="center">
					<v-col class="ma-0 pa-0" cols="11" align="left">
						<!-- 카메라그룹 생성(/camera-group/create)과 동일한 카메라 선택 UI (그룹명·안내문구 없음) -->
						<CameraTreeSelect v-model="selectedCameras" />
						<!-- 캔슬 / 추가하기 -->
						<v-col class="ma-0 pa-0 mt-5 pb-2" cols="12">
							<v-row class="ma-0 pa-0" align="center" justify="center">
								<v-btn width="8rem" height="2rem" class="ma-0 pa-0" id="grey_btn"
									elevation="0" @click="dialog = false">
									{{ t('cancel') }}
								</v-btn>
								<v-btn width="8rem" height="2rem" class="ma-0 pa-0 ml-2" id="blue_btn"
									elevation="0" @click="confirmAdd">
									{{ t('add2') }}
								</v-btn>
							</v-row>
						</v-col>
					</v-col>
				</v-row>
			</template>
		</custom-dialog>
	</v-dialog>
</template>

<script>
import mixin from '@/mixin';
import CustomDialog from '@/components/Modal.vue';
import CameraTreeSelect from '@/components/CameraTreeSelect.vue';
export default {
	props: {
		dialogVisible: Boolean,
	},
	components: {
		CustomDialog, CameraTreeSelect
	},
	mixins: [mixin.common],
	data: () => ({
		dialog: false,
		selectedCameras: [],
	}),
	watch: {
		dialogVisible: function (item) {
			this.dialog = item;
			if (item) this.selectedCameras = []; // 열릴 때 선택 초기화
		},
		dialog: function (item) {
			this.$emit('visible', item);
		},
	},
	methods: {
		confirmAdd() {
			this.$emit('add', this.selectedCameras);
			this.dialog = false;
		}
	}
}
</script>

<style lang="scss" scoped>
</style>
